/* generated using openapi-typescript-codegen -- do no edit */
/* istanbul ignore file */
/* tslint:disable */
/* eslint-disable */

export enum PlanMigrationAttributes {
    PAYMARKET = 'paymarket',
    CURRENCY = 'currency',
    JOB_SLOTTING = 'jobSlotting',
    SURVEY = 'survey',
    SALARY_RANGE_ELIGIBILITY = 'salaryRangeEligibility',
    LEVEL_MAPPINGS = 'levelMappings',
    MRP = 'mrp',
    TARGET_TYPE_OF_PAY = 'targetTypeOfPay',
    TAG = 'tag',
    COMPOSITE_COMMENT = 'compositeComment',
    REMOVE_ROLLUP_JOB_MAPPINGS = 'removeRollupJobMappings',
    REMOVE_JOB_MAPPINGS_AND_CUT_SELECTIONS = 'removeJobMappingsAndCutSelections',
}
